import * as __au2ViewDef from './object-list.html';
import { bindable, customElement, EventAggregator, IDisposable, inject, } from "aurelia";
import { SelectedObjectService } from "../../resources/services/selected-object";
import { BackendService } from "../../resources/services/backend-service";
import { MetaObject } from "../../../../mmar-global-data-structure/models/meta/Metamodel_metaobjects.structure";
import { UserService } from "../../resources/services/user-service";

@customElement({ ...__au2ViewDef, name: "object-list" })
@inject(EventAggregator)
@inject(SelectedObjectService)
export class objectList {
    @bindable objectList: MetaObject[] = [];
    @bindable type = "";
    selectedobject: MetaObject;
    searchTerm: string = "";
    filteredItems: MetaObject[] = [];
    private subscription: IDisposable;

    constructor(
        private eventAggregator: EventAggregator,
        private selectedObjectService: SelectedObjectService,
        private backendService: BackendService,
        private userService: UserService,
    ) {
    }

    async attached() {
        // sort the object alphabetically
        this.objectList.sort((a, b) => a.name.localeCompare(b.name));
        this.filteredItems = this.objectList;
        this.subscription = this.eventAggregator.subscribe(
            "SelectedObjectChanged",
            (payload: { selectedObject: MetaObject; type: string }) => {
                this.selectedobject = payload.selectedObject;
            },
        );
    }

    activate() {
    }

    detaching() {
        this.subscription.dispose();
    }

    async addNewObject() {
        const retrivedObject = await this.backendService.createNewObject(this.type);
        this.selectedObjectService.setSelectedObject(
            retrivedObject.uuid
        );
    }

    async removeObject() {
        const res = await this.backendService.deleteObject(
            this.selectedobject.uuid,
            this.type,
        );
        if (res.status === 200) {
            this.filteredItems = this.objectList;
            this.selectedObjectService.deselectObject();
        }
    }

    filterItems() {
        if (this.searchTerm) {
            const searchTermLower = this.searchTerm.toLowerCase();
            this.filteredItems = this.objectList.filter((item) => {
                return item.name.toLowerCase().includes(searchTermLower);
            });
        } else {
            // If no search term, display all items
            this.filteredItems = this.objectList;
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = objectList;

    // @ts-ignore
    const proto = objectList.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }